import React from 'react';

import '../css/nav-arrow.less';

const PrevArrow = ({ currentSlide, previousSlide, className }) => {
    let disabled = '';
    if(currentSlide == 0) disabled = ' arrow-disabled'
    return (
        <div className={`nav-arrow prev${className ? ' '+className : ''}`+disabled} onClick={previousSlide}></div>
    );
}

const NextArrow = ({ currentSlide, nextSlide, slideCount, slidesToShow, className, customSlideCount }) => {
    let disabled = '';
    if( (typeof customSlideCount !== 'number' && currentSlide >= ( slideCount - slidesToShow )) || (typeof customSlideCount === 'number' && currentSlide >= customSlideCount-1)) disabled = ' arrow-disabled'
    return (
        <div className={`nav-arrow next${className ? ' '+className : ''}`+disabled} onClick={nextSlide}></div>
    )
}

export default { PrevArrow, NextArrow }
